import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SellerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { state: { user, isAuthenticated, loading } } = useAuth();

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  return isAuthenticated && (user?.role === 'seller' || user?.role === 'admin') ? <>{children}</> : <Navigate to="/" />;
};

export default SellerRoute;